import AccountMaster from "../pages/masters/AccountMaster";
import TermDepositMaster from "../pages/masters/TermDepositMaster";

// Options enums
export const OptionsStatus = Object.freeze({
  AccountMaster: "ACCOUNT_MASTER",
  LoanMaster: "LOAN_MASTER",
  MemberMaster: "MEMBER_MASTER",
  SocietyMaster: "SOCIETY_MASTER",
  TermDeposit: "TERM_DEPOSIT",
  DepositAccounts: "DEPOSIT_ACCOUNTS",
});
